import { hbs } from 'ember-cli-htmlbars';
export default hbs("<input type=\'file\' onchange={{this.selectFiles}} ...attributes />")